import React from "react";
import { Redirect } from "react-router-dom";
import { FeatureFlags, useFeatureFlag } from "../../feature-flags/FeatureFlagContext";

/**
 * Routes the "Create Cashback Config" entry point, composing two feature flags:
 * - When `cashback-v2-enabled` is off, always routes to the v1 editor, regardless of the create-default flag.
 * - When `cashback-v2-enabled` is on, follows `admin-cashback-v2-create-default`: true → v2 editor, false → v1 editor.
 */
export default function CashbackConfigCreateGate() {
  const cashbackV2Enabled = useFeatureFlag(FeatureFlags.CASHBACK_V2_ENABLED);
  const createV2ByDefault = useFeatureFlag(FeatureFlags.ADMIN_CASHBACK_V2_CREATE_DEFAULT);
  const routeToV2 = cashbackV2Enabled && createV2ByDefault;
  return routeToV2 ? <Redirect to="/cashback/v2/config/new" /> : <Redirect to="/cashback/config/new" />;
}
